import { api } from './NetworkUtility';

//api call to ping server to keep user session alive
export const ping = () => {
    const url = `/ping`;

    api.get(url)
        .then(res => res.status)
        .then((status) => {
            //log user out in unlikely event a non 200 status is returned or if system is down
            if (status !== 200) {
                logoutRedirect();
            }
        })
        .catch(function (error) {
            //log user out upon error
            logoutRedirect();
        }
    );
}

export const logout = () => {
    const url = `/user-logout`;

    api.post(url, null)
        .then(res => res.status)
        .then((status) => {
        })
        .catch(function (error) {
        }
    );
}

export const logoutRedirect = () => {
    const loginUrl = process.env.REACT_APP_LOGIN_URL;

    const url = `/user-logout`;

    api.post(url, null)
        .then(res => res.status)
        .then((status) => {
            window.location = loginUrl;
        })
        .catch(function (error) {
            //still log out user
            window.location = loginUrl;
        }
    );
}